import { render, staticRenderFns } from "./SuportPosStatus.vue?vue&type=template&id=627e83cc&"
import script from "./SuportPosStatus.vue?vue&type=script&lang=js&"
export * from "./SuportPosStatus.vue?vue&type=script&lang=js&"
import style0 from "./SuportPosStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports